// Constantes de colores del sistema
export const COLORS = {
  // Color principal del sistema
  PRIMARY: '#23AAAF',

  // Versión más clara del color principal para eventos pasados
  PRIMARY_LIGHT: '#7BC5C8',

  // Colores de estado de turnos
  APPOINTMENT_STATUS: {
    PENDING: '#23AAAF',
    COMPLETED: '#7BC5C8',
    CANCELLED: '#6b7280',
    NO_SHOW: '#9ca3af'
  },

  // Colores del sistema
  SYSTEM: {
    SUCCESS: '#10b981',
    ERROR: '#ef4444',
    WARNING: '#fbbf24',
    INFO: '#3b82f6',
    GRAY: '#6b7280'
  }
};

// Función para obtener el color de estado de un turno
export const getAppointmentColor = (estado, isPast = false) => {
  const normalizedEstado = String(estado || 'PENDIENTE').toUpperCase();

  const statusColors = {
    PENDIENTE: isPast
      ? COLORS.PRIMARY_LIGHT
      : COLORS.APPOINTMENT_STATUS.PENDING,

    REALIZADO: COLORS.APPOINTMENT_STATUS.COMPLETED,

    CANCELADO: COLORS.APPOINTMENT_STATUS.CANCELLED,

    NO_ASISTIO: COLORS.APPOINTMENT_STATUS.NO_SHOW
  };

  return statusColors[normalizedEstado] || COLORS.APPOINTMENT_STATUS.PENDING;
};